<template>


  <div :style="getStyle">

    <div style="display: flex;align-items: flex-start">
      <div style="flex: 1;font-size: 14px;font-weight: bold;color: #15224C;margin-left: 6px">{{element.style.title}}</div>
      <el-form inline label-width="auto">
        <el-form-item label="搜索">
          <el-input v-model="keyword" placeholder="请输入内容" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="getData" border :height="element.h-60-32"
              :header-cell-style="{color:'#181A1D',backgroundColor:'#F1F2F3'}" v-loading="loading">
      <el-table-column label="序号" :width="70" v-if="element.style?.enableNumber" align="center">
        <template #default="scope">
          {{ (page.currentPage - 1) * page.pageSize  + (scope.$index + 1) }}
        </template>
      </el-table-column>
      <el-table-column v-for="(key,index) in Object.keys(data[0]||{})" :key="index" :label="key" :prop="key"></el-table-column>
    </el-table>


    <div style="display: flex;align-items: center">

      <div style="flex: 1;margin:4px 0 0 6px">共 <span style="font-weight: bold">{{getSize}}</span> 条数据</div>
      <el-pagination layout="prev, pager, next" :total="getSize" style="margin: 6px 10px 0 0 ;" @current-change="handleCurrentChange"/>

    </div>


  </div>
</template>


<script>
import chartFactory from "@/components/design-report/chartFactory";

export default {
  props: {
    report: {
      type: Object,
      default: () => {
      }
    },
    element: {
      type: Object,
      default: () => {
        return {}
      }
    },
    elements: {
      type: Array,
      default: () => []
    },
    ratio: {
      type:Object,
      default:()=>{
        return {
          width: 1,
          height: 1
        }
      }
    },
    mode: {
      type: String,
      default: 'edit'
    },
    diving: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    "element.option.data": {
      handler(newValue, oldValue) {
        this.preview()
      },
      immediate: true
    }
  },
  created() {
    if (this.mode === 'preview') {
      this.loading = true;
      chartFactory.preview(this.report.id, this.element, this.elements, () => this.loading = false);
    }
  },
  computed: {
    getData() {


      if(this.keyword){
        return this.data.filter(item => {
          return Object.keys(item).some(key => {
            return item[key] && item[key].toString().includes(this.keyword)
          })
        }).slice((this.page.currentPage - 1) * this.page.pageSize, this.page.currentPage * this.page.pageSize)
      }else{

        let  tableData = this.data.slice((this.page.currentPage - 1) * this.page.pageSize, this.page.currentPage * this.page.pageSize);


        return tableData;
      }


    },
    getSize(){
      if(this.keyword){
        return this.data.filter(item => {
          return Object.keys(item).some(key => {
            return item[key] && item[key].toString().includes(this.keyword)
          })
        }).length
      }else{
        return this.data.length;
      }
    },
    getStyle() {

      if (this.mode === 'edit') {
        return {
          width: `${this.element.w * this.ratio.width}px`,
          height: `${this.element.h * this.ratio.height}px`
        }
      }
      else {
        return {
          position: this.diving ? 'none' : 'absolute',
          'box-sizing': 'border-box',
          width: `${this.element.w * this.ratio.width}px`,
          height: `${this.element.h * this.ratio.height}px`,
          transform: this.diving ? 'none' : `translate(${this.element.x * this.ratio.width}px, ${this.element.y * this.ratio.height}px)`,
          'z-index': this.element.index
        }
      }


    }
  },
  data() {
    return {
      data: [
        {
          省份: '浙江',
          城市: '杭州',
          区: '西湖区',
          销售额: 1000,
          利润: 500
        },
        {
          省份: '浙江',
          城市: '杭州',
          区: '西湖区',
          销售额: 1000,
          利润: 500
        },
        {
          省份: '浙江',
          城市: '杭州',
          区: '西湖区',
          销售额: 1000,
          利润: 500
        },
        {
          省份: '浙江',
          城市: '杭州',
          区: '西湖区',
          销售额: 1000,
          利润: 500
        },
        {
          省份: '浙江',
          城市: '杭州',
          区: '西湖区',
          销售额: 1000,
          利润: 500
        },
      ],
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      keyword:'',
      loading: false,
    }
  },
  methods: {
    preview() {
      if (this.element.option.data) {
        this.data = this.element.option.data;
        this.page.currentPage = 1;
        this.page.total = this.element.option.data.length;
      }
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
    }
  }


}

</script>

<style scoped lang="scss">

</style>